import { makeStyles } from '@material-ui/core/styles';
import backgroundImage from './assets/bg3.jpg';

export default makeStyles((theme) => ({
    root: {
        height: '100vh'
    },
    image: {
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }
}
))